module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"valid_message_length":"(有效字数: {0} 字)"}}')
  delete Component.options._Ctor
}
